import type { ProductKeys } from '../../../common/constants/products';
import { isSearchable } from '../../../common/utils/relay/is-searchable';

export type SearchPageMode = 'BOOTSTRAP_LOADING' | 'LANDING' | 'RESULTS' | 'CQL_RESULTS';

/**
 * Single source of truth for which main-content UI state the search page should render.
 */
export function getSearchPageMode(args: {
	bootstrapReady: boolean;
	availableProducts: ProductKeys[];
	selectedProduct: ProductKeys | undefined;
	searchQuery: string;
	hasAnyFilterSelected: boolean;
	cql: string | undefined;
}): SearchPageMode {
	// If bootstrap is not ready, we can only show config-loading skeletons.
	if (!args.bootstrapReady) {
		return 'BOOTSTRAP_LOADING';
	}

	// CQL is only used when there's no non-CQL query (searchQuery or selected filters takes precedence if either are present).
	const hasSearchQuery = args.searchQuery.trim() !== '';
	if (args.cql && !hasSearchQuery && !args.hasAnyFilterSelected) {
		return 'CQL_RESULTS';
	}

	// If the current search is valid, use results
	if (isSearchable(args.availableProducts, args.selectedProduct, args.searchQuery)) {
		return 'RESULTS';
	}

	// Fallback for invalid searches.
	return 'LANDING';
}
